import HttpJson from './json'
import HttpFormData from './formData'
import { CHATSO_API_URL } from '~/constants/environment'

const httpJson = HttpJson.create()
const httpFormData = HttpFormData.create()
const httpFrontApiFormData = HttpFormData.create({
  baseURL: CHATSO_API_URL,
})

let proxyUrl: string | undefined

try {
  const chatsoURL = new URL(CHATSO_API_URL)
  proxyUrl = `${chatsoURL.origin}/proxy`
} catch {}

const csClient = {
  json: httpJson,
  formData: httpFormData,
  frontApiFormData: httpFrontApiFormData,
  proxyUrl,
}

export default csClient
